import React from 'react';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';
import getActiveFilters from './helpers/getActiveFilters';
import getActiveFilter from './helpers/getActiveFilter';
import getActiveKey from './helpers/getActiveKey';
import getActiveBpm from './helpers/getActiveBpm';

export const _ActiveFilters = ({
    bpmlowerbound,
    bpmupperbound,
    genres,
    instruments,
    sfxs,
    keyquality,
    keyrootnote,
    tags,
    textsearch,
    removeFilter,
}: {
    bpmlowerbound: string | null;
    bpmupperbound: string | null;
    genres: string[] | null;
    instruments: string[] | null;
    sfxs: string[] | null;
    keyquality: string | null;
    keyrootnote: string | null;
    tags: string[] | null;
    textsearch: string[] | null;
    removeFilter: (modifiers: ModifiersPayload[]) => void;
}) => (
    <>
        {getActiveFilters(FiltersParams.instruments, instruments, removeFilter)}
        {getActiveFilters(FiltersParams.sfxs, sfxs, removeFilter)}
        {getActiveFilters(FiltersParams.genres, genres, removeFilter)}
        {getActiveFilters(FiltersParams.tags, tags, removeFilter)}
        {getActiveFilter(FiltersParams.keyquality, keyquality, removeFilter)}
        {getActiveKey(keyrootnote, removeFilter)}
        {getActiveBpm(bpmlowerbound, bpmupperbound, removeFilter)}
        {getActiveFilters(FiltersParams.textsearch, textsearch, removeFilter)}
    </>
);

const ActiveFilters = () => {
    const {
        bpmlowerbound,
        bpmupperbound,
        genres,
        instruments,
        sfxs,
        keyquality,
        keyrootnote,
        tags,
        textsearch,
    } = useCurrentSearchState();

    const { removeFilter: searchBarRemoveFilter } = useSearchBarContext();

    return (
        <_ActiveFilters
            bpmlowerbound={bpmlowerbound}
            bpmupperbound={bpmupperbound}
            genres={genres}
            instruments={instruments}
            sfxs={sfxs}
            keyquality={keyquality}
            keyrootnote={keyrootnote}
            tags={tags}
            textsearch={textsearch}
            removeFilter={searchBarRemoveFilter}
        />
    );
};

export default ActiveFilters;
